import { memo } from 'react';
import type { CompanyAnnualRevenueProps as Props } from './types';
import { useCompanyAnnualRevenue } from './use-company-annual-revenue';
import { TableCellTypography } from '@aibees/shared/components';

export const CompanyAnnualRevenue = memo(({ value }: Props) => {
  const item = useCompanyAnnualRevenue(value);
  return <TableCellTypography item={item} hasCapitalize={false} />;
});

CompanyAnnualRevenue.displayName = 'CompanyAnnualRevenue';
